var React = require('react');

function Ajna (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M29,19c0,5.522-4.478,10-10,10\n\tc-5.523,0-10-4.478-10-10c0-5.523,4.477-10,10-10C24.522,9,29,13.477,29,19z M13.487,10.651C12.595,10.244,11.643,10,10.642,10\n\tc-6.084,0-6.204,6-9.204,9c3,3,3.12,9,9.204,9c1.003,0,1.957-0.245,2.851-0.654 M24.508,27.346C25.401,27.755,26.355,28,27.358,28\n\tc6.084,0,6.204-6,9.204-9c-3-3-3.12-9-9.204-9c-1.001,0-1.953,0.244-2.846,0.651 M10.341,14l8.911,14.994 M27.659,14.001l-17.318,0\n\t M19.251,28.994l8.408-14.993"}));
}

Ajna.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = Ajna;

Ajna.default = Ajna;
